import React from "react";

export const FunctionInput = (props) => {
    const {label, value, onChange} = props;
    return (
        <div className="predicate-box boost">
            <div className="type-selector">
                <button>{label}</button>
            </div>
            <input type="text"
                   value={value}
                   onChange={onChange}
            />
        </div>
    )
}